import SportsEventListItem from './SportsEventListItem';

export default SportsEventListItem;
